export const propertyMixin = {
    methods: {
        formatAskingPrice: function (property) {
            if (property.PropertySaleTypeString == 'for_sale') {
                if (property.PropertyAskingPrice === 0) {
                    return '£TBC'
                }

                if (property.PropertySalePriceTypeString == 'sale_no_refinement') {
                    return '£' + this.formatMoney(property.PropertyAskingPrice)
                }

                if (property.PropertySalePriceTypeString == 'sale_offers_in_excess') {
                    return 'Offers over £' + this.formatMoney(property.PropertyAskingPrice)
                }

                if (property.PropertySalePriceTypeString == 'sale_offers_from') {
                    return 'From £' + this.formatMoney(property.PropertyAskingPrice)
                }
            }

            if (property.PropertySaleTypeString == 'for_rent') {
                if (property.PropertyRentalRent === 0) {
                    return '£TBC'
                }

                if (property.PropertyRentalRentTypeString == 'per_annum') {
                    return '£' + this.formatMoney(property.PropertyRentalRent) + ' per year'
                }

                if (property.PropertyRentalRentTypeString == 'per_square_foot') {
                    return '£' + this.formatMoney(property.PropertyRentalRent) + ' per square foot'
                }
            }
        }
    }
}